/**
 * Verified Reviews Grid Section JavaScript
 *
 * Two independent pieces, both adapted from the IntersectionObserver +
 * animation-toggle + speed pattern established in section-statistics-reveal.js:
 *  1. Scroll reveal for the section headline (right-to-left slide) and,
 *     optionally, a staggered fade/rise for each review card.
 *  2. Per-card "tap to read more" expand/collapse — plain click handling,
 *     unrelated to scroll animation and unaffected by the animation toggle.
 */

(function () {
  function revealHeader(header) {
    header.classList.add("is-revealed");
  }

  function revealCard(card) {
    card.classList.add("is-revealed");
  }

  function initScrollAnimation(section) {
    var animationEnabled = section.dataset.animation !== "false";
    var header = section.querySelector(".vrg-header");
    var cards = Array.prototype.slice.call(section.querySelectorAll(".vrg-card"));

    if (!animationEnabled) {
      if (header) revealHeader(header);
      cards.forEach(revealCard);
      return;
    }

    if (!("IntersectionObserver" in window)) {
      if (header) revealHeader(header);
      cards.forEach(revealCard);
      return;
    }

    if (header) {
      var headerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealHeader(entry.target);
              headerObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );
      headerObserver.observe(header);
    }

    if (cards.length) {
      var cardObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealCard(entry.target);
              cardObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
      );
      cards.forEach(function (card) {
        cardObserver.observe(card);
      });
    }
  }

  function initExpandToggles(section) {
    var toggles = section.querySelectorAll("[data-vrg-expand-toggle]");
    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var card = toggle.closest(".vrg-card");
        if (!card) return;
        var expanded = card.classList.toggle("is-expanded");
        toggle.textContent = expanded
          ? toggle.getAttribute("data-collapse-label") || "Show less"
          : toggle.getAttribute("data-expand-label") || "Tap to read more";
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      });
    });
  }

  function initSection(section) {
    if (section.dataset.vrgInitialized === "true") return;
    section.dataset.vrgInitialized = "true";
    initScrollAnimation(section);
    initExpandToggles(section);
  }

  function initAll() {
    document.querySelectorAll(".vrg-section").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector(".vrg-section")
      : null;
    if (section) initSection(section);
  });
})();
